module.exports = __webpack_public_path__ + "static/media/hero2.aed86db9.jpg";